import * as React from "react";
import tw, { styled } from "twin.macro";

import Page from "app/components/Page";
import { useNavigate } from "react-router-dom";
import ProcessingView from "./components/ProcessingView";
import Completed from "app/components/Payment/Completed";
import MakePayment from "./components/MakePayment";

export default function Payment() {
  const navigate = useNavigate();
  const [step, setStep] = React.useState(0);

  const pageTitles = ["Make Payment", "Processing payment"];
  return (
    <StyledPage
      title={pageTitles[step]}
      onBack={step === 0 ? () => navigate(-1) : undefined}
    >
      {step === 0 && <MakePayment onContinue={() => setStep(1)} />}
      {step === 1 && <ProcessingView onContinue={() => setStep(2)} />}
      {step === 2 && <Completed />}
    </StyledPage>
  );
}

const StyledPage = styled(Page)`
  > div > .body {
    ${tw`mobile:px-[8px]`};
  }
`;
